import { Rate as AntRate } from 'antd';
import styled from 'styled-components';

export const Rate = styled(AntRate)``;
